/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import ApiHelper from '../../../utils/apiHelper';
import ReportFileExports from 'components/Reports/FileExports';
import MainCard from 'components/Cards/MainCard';
import SubCard from 'components/Cards/SubCard';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box,
    Paper,
    Menu,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { gridSpacing } from 'utils/constants';
import { toast } from 'react-toastify';
import { API_URL } from 'utils/constants';
import { handleDeviceColumns } from '../../../utils/commonHelpers';
import RightClickOptionsDialog from '../Devices/RightClickOptionsDialog';

const ManagementViewsDetails = () => {
    const theme = useTheme();
    const gridRef = useRef();
    const { id } = useParams();
    const viewsList = useSelector((state) => state.management.viewsList);
    const groups = useSelector((state) => state.management.groups);
    const deviceTypes = useSelector((state) => state.management.deviceTypes);
    const policies = useSelector((state) => state.management.policies);
    const licenses = useSelector((state) => state.management.licenses);
    const labels = useSelector((state) => state.management.labels);
    const { userInfo } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [assetViewsData, setAssetViewsData] = useState([]);
    const [csvDownloadFileHeaders, setCsvDownloadFileHeaders] = useState([]);

    const [viewName, setViewName] = useState('');
    const [groupId, setGroupId] = useState(0);
    const [deviceTypeId, setDeviceTypeId] = useState(0);
    const [policyId, setPolicyId] = useState(0);
    const [licenseId, setLicenseId] = useState(0);
    const [labelId, setLabelId] = useState(0);
    const [groupsData, setGroupsData] = useState([]);
    const [deviceTypesData, setDeviceTypesData] = useState([]);
    const [policiesData, setPoliciesData] = useState([]);
    const [licensesData, setLicensesData] = useState([]);
    const [labelsData, setLabelsData] = useState([]);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25
    });
    const [viewsTotalLength, setViewsTotalLength] = useState(0);
    const [columnDefs, setColumnDefs] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [contextMenu, setContextMenu] = useState(null);
    const [isScriptAvailable, setScriptAvailable] = useState(false);
    const [showContextMenuDialog, setShowContextMenuDialog] = useState(false);
    const [rightClickOption, setRightClickOption] = useState('');
    const [selectedViews, setSelectedViews] = useState([]);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    useEffect(() => {
        getDeviceColumns();
    }, []);

    useEffect(() => {
        setGroupsData(groups);
        setDeviceTypesData(deviceTypes);
        setPoliciesData(policies);
        setLicensesData(licenses);
        setLabelsData(labels);
    }, [groups, deviceTypes, policies, licenses, labels]);

    useEffect(() => {
        if (viewsList.length > 0) {
            const viewInfo = viewsList[parseInt(id)];
            const newGroupId = parseInt(viewInfo.groups) || 0;
            const newDeviceTypeId = parseInt(viewInfo.device_type_id) || 0;
            const newPolicyId = parseInt(viewInfo.policies) || 0;
            const newLicenseId = parseInt(viewInfo.licenses) || 0;
            const newLabelId = parseInt(viewInfo.labels) || 0;
            setViewName(viewInfo.view_name);
            setGroupId(newGroupId);
            setDeviceTypeId(newDeviceTypeId);
            setPolicyId(newPolicyId);
            setLicenseId(newLicenseId);
            setLabelId(newLabelId);
            const labelId = parseInt(newLabelId);
            let label = labels.find((data) => data.id === labelId);
            const label_id = labelId === 0 ? [] : [label?.name];
            getassetViewsData({
                page: 0,
                pageSize: paginationModel.pageSize,
                groupId: newGroupId,
                deviceTypeId: newDeviceTypeId,
                policyId: newPolicyId,
                licenseId: newLicenseId,
                label_id
            });
        }
    }, [viewsList]);

    const getassetViewsData = ({ page, pageSize, groupId, deviceTypeId, policyId, licenseId, label_id }) => {
        setLoading(true);
        ApiHelper.post(API_URL.MANAGEMENT_VIEWS, {
            group_id: groupId === 0 ? [] : [groupId],
            device_type_id: deviceTypeId === 0 ? [] : [deviceTypeId],
            policy_id: policyId === 0 ? [] : [policyId],
            license_id: licenseId === 0 ? [] : [licenseId],
            label_id: label_id,
            page_number: page,
            page_size: pageSize
        })
            .then((res) => {
                setAssetViewsData(res.data.data);
                setViewsTotalLength(res.data.total);
                let groupName = 'Any';
                let deviceTypeName = 'Any';
                for (let i = 0; i < groupsData.length; i++) {
                    if (groupsData[i].id === groupId) {
                        groupName = groupsData[i].name;
                    }
                }
                for (let i = 0; i < deviceTypesData.length; i++) {
                    if (deviceTypesData[i].id === deviceTypeId) {
                        deviceTypeName = deviceTypesData[i].name;
                    }
                }
                const temp = [
                    { label: 'Group Name', value: groupName },
                    { label: 'Device Type', value: deviceTypeName }
                ];
                // setFiltersData(temp);
                setLoading(false);
            })
            .catch(() => {
                setAssetViewsData([]);
                toast.warning('There is no view data');
                setLoading(false);
            });
    };

    const getDeviceColumns = () => {
        ApiHelper.get('/api/management/device_columns/2/')
            .then((res) => {
                const [columns_order, columns_visibility] = handleDeviceColumns(res.data);
                setColumnDefs(columns_order);
                const temp = [];
                columns_order.map((data) => {
                    temp.push({ label: data.headerName, key: data.field });
                });
                setCsvDownloadFileHeaders(temp);
            })
            .catch((err) => {
                if (err.response && err.response.status !== 401) {
                    toast.warn('There is device columns data');
                } else {
                    toast.error('Error fetching device columns');
                }
            });
    };

    const handleSelectionChange = (newSelection) => {
        const ids = new Set(newSelection);
        // const selectedViews = assetViewsData.filter((row) => ids.has(row.deviceid));
        setSelectedViews(assetViewsData.filter((row) => ids.has(row.deviceid)));
        setSelectedRows((prevSelected) => {
            // Create a new set to avoid modifying the previous state directly
            const updatedSelected = new Set(prevSelected);
            // Add selected rows from the current page
            newSelection.forEach((id) => {
                updatedSelected.add(id);
            });

            // Remove rows that are deselected from the current page
            assetViewsData.forEach((row) => {
                if (!newSelection.includes(row.deviceid)) {
                    updatedSelected.delete(row.deviceid);
                }
            });
            const selectedArray = Array.from(updatedSelected);

            return selectedArray;
        });
    };

    const updatePaginationModel = (newPaginationModel) => {
        setPaginationModel(newPaginationModel);
        getassetViewsData(newPaginationModel);
    };

    const handleContextMenu = (event) => {
        event.preventDefault();
        if (selectedRows.length === 0) {
            toast.warning('Please select the device');
            return true;
        }
        setContextMenu(contextMenu === null ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 } : null);
    };

    const handleCloseContextMenu = () => {
        setContextMenu(null);
    };

    const onClickContextMenu = (e) => {
        setShowContextMenuDialog(true);
        handleCloseContextMenu();
        setRightClickOption(e.target.id);
    };

    const handleCloseRightClickOptionsDialog = (isCancel = true) => {
        setShowContextMenuDialog(false);
    };

    const getScriptList = () => {
        ApiHelper.get(API_URL.MANAGEMENT_SCRIPTS)
            .then((res) => {
                setScriptAvailable(res.data.script_list.length > 0);
            })
            .catch(() => {
                setScriptAvailable(false);
            });
    };

    const handleRefresh = ({ groupId, deviceTypeId, policyId, licenseId, labelId }) => {
        let label = labels.find((data) => data.id === labelId);
        const label_id = labelId === 0 ? [] : [label?.name];
        getassetViewsData({ page: 0, pageSize: paginationModel.pageSize, groupId, deviceTypeId, policyId, licenseId, label_id });
    };

    const handleSave = () => {
        setOpenConfirmDialog(false);
        const viewInfo = viewsList[parseInt(id)];
        ApiHelper.put(`${API_URL.MANAGEMENT_VIEWS}${viewInfo.id}/`, {
            view_name: viewName,
            groups: groupId,
            device_type_id: deviceTypeId,
            policies: policyId,
            licenses: licenseId,
            labels: labelId
        })
            .then((res) => {
                if (res.status === 200) {
                    toast.success(res.data.message);
                    setOpenConfirmDialog(false);
                    setLoading(false);
                }
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to update view');
                setLoading(false);
            });
    };

    return (
        <MainCard title="View Management" cardHeaderTitle={`Device View (${viewName})`} cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={2} style={{ display: 'flex', flexDirection: 'column' }}>
                    {assetViewsData.length > 0 && (
                        <div style={{ float: 'right', justifyContent: 'flex-end', paddingBottom: '5px' }}>
                            <ReportFileExports
                                elementId="views"
                                downloadFileName="views"
                                downloadFileOption="csv"
                                data={assetViewsData}
                                headers={csvDownloadFileHeaders}
                            />
                        </div>
                    )}

                    <SubCard title="All VM Devices">
                        <Grid container>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Select Group</InputLabel>
                                    <Select
                                        label="Select Group"
                                        value={groupId}
                                        name="group"
                                        onChange={(e) => {
                                            const temp = Number(e.target.value);
                                            setGroupId(temp);
                                            handleRefresh({ groupId: temp, deviceTypeId, policyId, licenseId, labelId });
                                        }}
                                    >
                                        <MenuItem value={0}>Any</MenuItem>
                                        {groupsData.length > 0 &&
                                            groupsData.map((data, key) => (
                                                <MenuItem value={data.id} key={key}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Select Device Type</InputLabel>
                                    <Select
                                        label="Select Device Type"
                                        value={deviceTypeId}
                                        name="device_type"
                                        onChange={(e) => {
                                            const temp = Number(e.target.value);
                                            setDeviceTypeId(temp);
                                            handleRefresh({ groupId, deviceTypeId: temp, policyId, licenseId, labelId });
                                        }}
                                    >
                                        <MenuItem value={0}>Any</MenuItem>
                                        {deviceTypesData.length > 0 &&
                                            deviceTypesData.map((data, key) => (
                                                <MenuItem value={data.id} key={key}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Select Policy</InputLabel>
                                    <Select
                                        label="Select Policy"
                                        value={policyId}
                                        name="policy"
                                        onChange={(e) => {
                                            const temp = Number(e.target.value);
                                            setPolicyId(temp);
                                            handleRefresh({ groupId, deviceTypeId, policyId: temp, licenseId, labelId });
                                        }}
                                    >
                                        <MenuItem value={0}>Any</MenuItem>
                                        {policiesData.length > 0 &&
                                            policiesData.map((data, key) => (
                                                <MenuItem value={data.id} key={key}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Select License</InputLabel>
                                    <Select
                                        label="Select License"
                                        value={licenseId}
                                        name="license"
                                        onChange={(e) => {
                                            const temp = Number(e.target.value);
                                            setLicenseId(Number(e.target.value));
                                            handleRefresh({ groupId, deviceTypeId, policyId, licenseId: temp, labelId });
                                        }}
                                    >
                                        <MenuItem value={0}>Any</MenuItem>
                                        {licensesData.length > 0 &&
                                            licensesData.map((data, key) => (
                                                <MenuItem value={data.id} key={key}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Select Label</InputLabel>
                                    <Select
                                        label="Select Label"
                                        value={labelId}
                                        name="label"
                                        onChange={(e) => {
                                            const temp = Number(e.target.value);
                                            setLabelId(temp);
                                            handleRefresh({ groupId, deviceTypeId, policyId, licenseId, labelId: temp });
                                        }}
                                    >
                                        <MenuItem value={0}>Any</MenuItem>
                                        {labelsData.length > 0 &&
                                            labelsData.map((data, key) => (
                                                <MenuItem value={data.id} key={key} data-name={data.name}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <LoadingButton
                                    color="primary"
                                    variant="contained"
                                    sx={{ width: '100%' }}
                                    loading={loading}
                                    onClick={() => setOpenConfirmDialog(true)}
                                >
                                    Save
                                </LoadingButton>
                            </Grid>
                        </Grid>
                        <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)}>
                            <DialogTitle>Confirm Save</DialogTitle>
                            <DialogContent>
                                <DialogContentText>Are you sure you want to save these changes?</DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenConfirmDialog(false)}>Cancel</Button>
                                <Button onClick={handleSave} variant="contained">
                                    Save
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </SubCard>
                </Grid>
                <Grid item xs={10}>
                    <Paper id="assetViews">
                        {!loading && assetViewsData.length === 0 ? (
                            <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                                No data for views
                            </Typography>
                        ) : (
                            <Box
                                id="asset_devices"
                                sx={{
                                    fontSize: '12px',
                                    '& .device-column-header': {
                                        color: 'black',
                                        fontWeight: 'bold'
                                    },
                                    height: 'calc(100vh - 248px)',
                                    width: '100%'
                                }}
                            >
                                <DataGridPro
                                    columns={columnDefs}
                                    rows={assetViewsData}
                                    rowCount={viewsTotalLength}
                                    rowHeight={30}
                                    ref={gridRef}
                                    getRowId={(row) => row.deviceid}
                                    pagination
                                    initialState={{
                                        pagination: {
                                            paginationModel
                                        }
                                    }}
                                    pageSizeOptions={[25, 100, 250, 500, 1000]}
                                    checkboxSelection
                                    disableColumnMenu
                                    slotProps={{
                                        row: {
                                            onContextMenu: handleContextMenu,
                                            style: { cursor: 'context-menu' }
                                        },
                                        pagination: {
                                            showFirstButton: true,
                                            showLastButton: true
                                        }
                                    }}
                                    onRowSelectionModelChange={handleSelectionChange}
                                    sortingMode="server"
                                    // sortModel={sortModel}
                                    paginationMode={'server'}
                                    rowSelectionModel={Array.from(selectedRows)}
                                    loading={loading}
                                    onPaginationModelChange={updatePaginationModel}
                                    disableRowHeightAdjustment={false}
                                    getRowHeight={() => 30}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#f5f5f5', // Optional: Customize header background
                                            position: 'sticky', // Ensures headers are sticky
                                            top: 0,
                                            zIndex: 1 // Ensures headers stay above content when scrolling
                                        },
                                        '& .MuiDataGrid-virtualScroller': {
                                            overflowY: 'auto',
                                            overflowX: 'auto' // Enable horizontal scrolling
                                        },
                                        '& .MuiDataGrid-columnHeaderTitleContainer': {
                                            display: 'flex',
                                            justifyContent: 'center', // Center text horizontally
                                            alignItems: 'center', // Center text vertically
                                            height: '100%'
                                        }
                                    }}
                                />

                                <Menu
                                    open={contextMenu !== null}
                                    onClose={handleCloseContextMenu}
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                        contextMenu !== null
                                            ? {
                                                  top: contextMenu.mouseY,
                                                  left: contextMenu.mouseX
                                              }
                                            : undefined
                                    }
                                    componentsProps={{
                                        root: {
                                            onContextMenu: (e) => {
                                                e.preventDefault();
                                                handleCloseContextMenu();
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem id="wake" onClick={onClickContextMenu}>
                                        Wake
                                    </MenuItem>
                                    <MenuItem id="sleep" onClick={onClickContextMenu}>
                                        Sleep
                                    </MenuItem>
                                    <MenuItem id="restart" onClick={onClickContextMenu}>
                                        Restart
                                    </MenuItem>
                                    <MenuItem id="shutdown" onClick={onClickContextMenu}>
                                        ShutDown
                                    </MenuItem>
                                    <MenuItem id="group" onClick={onClickContextMenu}>
                                        Assign Group
                                    </MenuItem>
                                    <MenuItem id="policy" onClick={onClickContextMenu}>
                                        Assign Policy
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem id="label" onClick={onClickContextMenu}>
                                        Assign Label
                                    </MenuItem>
                                    {userInfo.admin_permissions.root_admin && (
                                        <MenuItem id="setBaseline" onClick={onClickContextMenu}>
                                            Set Baseline
                                        </MenuItem>
                                    )}
                                    <Divider />
                                    {userInfo.admin_permissions.root_admin && (
                                        <MenuItem id="getLogFile" onClick={onClickContextMenu}>
                                            Get Log File
                                        </MenuItem>
                                    )}
                                    <MenuItem id="upgrade" onClick={onClickContextMenu}>
                                        Upgrade/No Upgrade
                                    </MenuItem>
                                    <MenuItem id="license" onClick={onClickContextMenu}>
                                        License/Unlicensed/Monitor
                                    </MenuItem>
                                    {userInfo.admin_permissions.org_admin && (
                                        <MenuItem id="getTISData" onClick={onClickContextMenu}>
                                            Get TIS Data
                                        </MenuItem>
                                    )}
                                    {userInfo.admin_permissions.org_admin && isScriptAvailable && (
                                        <MenuItem id="script" onClick={onClickContextMenu}>
                                            Run Script
                                        </MenuItem>
                                    )}
                                </Menu>
                            </Box>
                        )}
                        {showContextMenuDialog && (
                            <RightClickOptionsDialog
                                option={rightClickOption}
                                onClose={handleCloseRightClickOptionsDialog}
                                devices={selectedViews}
                            />
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ManagementViewsDetails;
